var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('ul',{staticClass:"nav_menu_container"},_vm._l((_vm.items),function(item,i){return _c('li',{key:i},[_c('router-link',{attrs:{"to":_vm.getUrl(item.link)}},[_vm._v(_vm._s(item.link.title))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }